export default "__VITE_ASSET__CzOMxQQz__"